module.exports = __webpack_public_path__ + "static/media/welcome-home-top-banner.544edbd1.jpg";